export const DETAIL_TIERS = {
  steps: {
    commande: 'Informations commande',
  },
  titres: {
    commande: 'Informations commande',
  },
  commande: {
    nombreMoisPreavis: 'Nombre de mois préavis :',
  },
};

export const ADD_EDIT_TIERS = {
  titres: {
    commande: 'Informations commande',
  },
  commande: {
    nombreMoisPreavis: 'Nombre de mois préavis',
  },
};

export const ENCOURS_TIERS = {
  lettrePartiellement: 'Partiellement lettré',
  nonLettre: 'Non lettré',
  lettre: 'Lettré',
  lettreAction: 'Lettrer',
  delettreAction: 'Délettrer',
  enCoursClient: 'Encours Client',
  date: 'Date',
  libelle: 'Libellé',
  debit: 'Débit',
  credit: 'Crédit',
  resteAlettrer: 'Reste à lettrer',
  etat: 'Etat',
  action: 'Action',
  masquer: 'Masquer les mouvements lettrés',
  afficher: 'Afficher les mouvements lettrés',
  soldeTotal: 'Solde total : ',
  soldeInferieur: 'Restant dû au {date} :',
  soldeSuperieur: 'A rembourser au {date} :',
  lettrages: {
    title: 'Lettrer un mouvement',
    annuler: 'Annuler',
    valider: 'Valider',
    resteALettrer: 'Montant restant à lettrer',
    reglementN: 'Règlement n° ',
    factureN: 'Facture n° ',
    du: ' du ',
    dun: ' d\'un ',
    montantDe: 'montant de ',
  },
  type: {
    avoir: 'avoir',
    reglement: 'reglement',
    annulationReglement: 'annulation reglement',
  },
};

export const COMPTE_TIERS = {
  date: 'Date pièce',
  libelle: 'Libellé',
  debit: 'Débit',
  credit: 'Crédit',
  resteAlettrer: 'Reste à lettrer',
  type: 'Type pièce',
  numero: 'Numéro pièce',
  etatLettrage: 'Etat lettrage',
  solde: 'Solde',
  dateSolde: 'Date dernier mouvement',
  ecriture: 'Ecriture',
  actions: {
    filtre: 'Filtre',
    search: 'Rechercher',
  },
  filtres: {
    datePiece: 'Date pièce',
    datePieceDu: 'Du',
    datePieceAu: 'au',
    numeroPiece: 'Numéro de pièce',
    libelle: 'Libellé',
    montantsDebit: 'Montant débit',
    montantsCredit: 'Montant crédit',
    types: 'Types de pièces',
    etats: 'Etat lettrage',
    montantsDe: 'De',
    montantsA: 'à',
    errors: {
      messageErrorDate: 'La date de fin de période doit être postérieure à la date de début',
    },
  },
};

export const EXPORT_BALANCE_TIERS = {
  title: 'Export balance des tiers',
  dateDebut: 'Date début',
  dateFin: 'Date fin',
  errorDates: 'Les dates sont obligatoires',
};

export const EDITION_EXTRAIT_COMPTE_TIERS = {
  title: 'Grand livre',
};
